// extracted by mini-css-extract-plugin
module.exports = {"tab-select-input":"tab-select-input__1GQ4K","tab-item":"tab-item__3C-Rh","active":"active__1iopn"};